import { MakeCollectionPrivateShareSheetModalStore } from "@/components/modal/share-sheet/make-collection-private-share-sheet-modal-store";
import { observer } from "mobx-react-lite";
import {
  MDSButtonGroup,
  MDSDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSText,
  MDSTextVariant,
  MDSButton,
  MDSButtonVariant,
} from "@/mds";

export const MakeCollectionPrivateShareSheetModalContent = observer<{
  store: MakeCollectionPrivateShareSheetModalStore;
}>(function MakeCollectionPrivateShareSheetContent({ store }) {
  const targetDisplayNameText = store.targetDisplayName
    ? `${store.targetDisplayName}, the last collaborator`
    : "the last collaborator";

  return (
    <MDSDialog isOpen handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Make this collection private?
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          You are about to remove {targetDisplayNameText}. Do you wish to keep this collection
          shared with only yourself, or make it to private? Converting to private will make it
          visible to you alone and may result in losing access to some notes not individually shared
          with you.
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsLeft}>
        <MDSButton onClick={() => store.close()}>Cancel</MDSButton>
      </MDSButtonGroup>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={async () => await store.handleKeepCollectionShared()}>
          Keep as Shared
        </MDSButton>
        <MDSButton
          variant={MDSButtonVariant.DangerFilled}
          onClick={() => store.handleMakeCollectionPrivate()}
        >
          Make Private
        </MDSButton>
      </MDSButtonGroup>
    </MDSDialog>
  );
});
